import { useState } from "react";
import type { ReactNode } from "react";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { useAuth } from "../../hooks/useAuth";
import { LoadingSpinner } from "../LoadingSpinner";
import { ImpersonationBanner } from "../ImpersonationBanner";
import { Navigate } from "react-router-dom";

export function DashboardLayout({ children }: { children: ReactNode }): JSX.Element {
  const { user, isLoading, impersonatedBy } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <LoadingSpinner label="Loading session..." />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="min-h-screen bg-app-light bg-fixed bg-slate-50 transition-colors duration-200 dark:bg-none dark:bg-slate-900">
      {impersonatedBy && <ImpersonationBanner user={user} impersonatedBy={impersonatedBy} />}
      <Sidebar role={user.role} open={sidebarOpen} />
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-30 animate-fade-in bg-slate-900/30 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
      <div className="lg:pl-64">
        <Topbar user={user} onMenuClick={() => setSidebarOpen((v) => !v)} />
        <main className="animate-fade-in-up p-4 lg:p-8">{children}</main>
      </div>
    </div>
  );
}
